module.exports = __webpack_public_path__ + "static/media/vodoo_mototurismo_1.7dcfa494.jpg";